const selectorsAddresses = {
  addressContainer: '[data-address]',
  addressFields: '[data-address-fields]',
  addressToggle: '[data-address-toggle]',
  addressForm: '[data-address-form]',
  addressDeleteForm: '[data-address-delete-form]',
};
const hideClass = 'hide';
const formOpenedClass = 'form-opened';

function initializeAddressForm(container) {
  const addressFields = container.querySelector(selectorsAddresses.addressFields);
  const addressForm = container.querySelector(selectorsAddresses.addressForm);
  const deleteForm = container.querySelector(selectorsAddresses.addressDeleteForm);

  container.querySelectorAll(selectorsAddresses.addressToggle).forEach((button) => {
    button.addEventListener('click', function() {
      addressForm.classList.toggle(hideClass);
      document.querySelector('.addresses-list').classList.toggle(formOpenedClass);
      if (document.querySelector('.addresses-list').classList.contains(formOpenedClass)) {
        document.querySelectorAll(selectorsAddresses.addressContainer).forEach((container) => {
          container.classList.add('hide')
        });
        this.closest('[data-address]').classList.remove('hide');
        document.querySelector('.addresses-list.form-opened').style.height = this.closest('[data-address]').querySelector('[data-address-form]').clientHeight + 'px';
        window.scrollTo(0,0);
      } else {
        document.querySelectorAll(selectorsAddresses.addressContainer).forEach((container) => {
          container.classList.remove('hide')
        });
        document.querySelector('.addresses-list').style.height = ''
      }
    });
  });

  AddressForm(addressFields, 'en');

  if (deleteForm) {
    deleteForm.addEventListener('submit', (event) => {
      const confirmMessage = deleteForm.getAttribute('data-confirm-message');

      if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        event.preventDefault();
      }
    });
  }
}

const addressForms = document.querySelectorAll(selectorsAddresses.addressContainer);

if (addressForms.length) {
  addressForms.forEach((addressContainer) => {
    initializeAddressForm(addressContainer);
  });
}

document.querySelector('ul.account-nav').addEventListener("click", function() {
  if (this.classList.contains('opened')) {
    this.classList.remove('opened')
  } else {
    this.classList.add('opened')
  }
});